/*
 * assets/js/src/recenze-davky.js — „Načíst dalších N recenzí" na Referencích.
 *
 * Server kreslí jednu dávku (9 karet) a tenhle modul další PŘIPOJUJE pod
 * stávající, bez reloadu. Vzor je `assets/js/blog-listing.js`, které dělá
 * totéž nad výpisem blogu.
 *
 * FAIL-OPEN. Tlačítko je `<a href="?recenze=N#recenze">` vykreslené
 * SERVEREM, ne `<button>` vyrobené skriptem. Když fetch selže (výpadek,
 * 5xx, cache) nebo skript neběží vůbec, zůstane odkaz odkazem a prohlížeč
 * na tu adresu přejde — server vykreslí N × 9 karet. Stránka je tak
 * průchozí i pro roboty a čtečky.
 *
 * Nové karty se po připojení musí projít modulem `recenze`, jinak by
 * u dlouhých textů chybělo tlačítko „Zobrazit celé" — proto se volá znovu
 * (je idempotentní, tlačítka už odkrytá přeskočí).
 */

import * as recenze from './recenze.js';

export function init() {
	const mrizka = document.querySelector('[data-za-recenze]');
	const odkaz = document.querySelector('[data-za-recenze-dalsi]');
	if (!mrizka || !odkaz) return 0;

	let nacita = false;

	odkaz.addEventListener('click', (e) => {
		const href = odkaz.getAttribute('href');
		if (!href || nacita) return;
		e.preventDefault();
		nacita = true;
		odkaz.setAttribute('aria-busy', 'true');
		odkaz.style.opacity = '0.6';

		fetch(href, { credentials: 'same-origin' })
			.then((r) => {
				if (!r.ok) throw new Error('HTTP ' + r.status);
				return r.text();
			})
			.then((html) => {
				const doc = new DOMParser().parseFromString(html, 'text/html');
				const nova = doc.querySelector('[data-za-recenze]');
				if (!nova) throw new Error('davka bez mrizky');

				// Připojí se JEN karty, které tu ještě nejsou — dávka
				// obsahuje i ty předchozí, protože server kreslí od začátku.
				const mam = mrizka.querySelectorAll('.rev').length;
				const prichozi = [...nova.querySelectorAll('.rev')].slice(mam);
				for (const karta of prichozi) mrizka.appendChild(karta);

				// Tlačítko z nové odpovědi: buď má vyšší číslo a nový
				// popisek, nebo tam už není a s ním zmizí i tady.
				const novyOdkaz = doc.querySelector('[data-za-recenze-dalsi]');
				if (novyOdkaz) {
					odkaz.setAttribute('href', novyOdkaz.getAttribute('href') || '');
					odkaz.textContent = novyOdkaz.textContent;
				} else {
					const obal = odkaz.closest('.loadmore');
					if (obal) obal.remove();
					else odkaz.remove();
				}

				recenze.init();
			})
			.catch(() => {
				// Fail-open: odkaz zůstane funkční, další klepnutí stránku načte.
				window.location.href = href;
			})
			.finally(() => {
				nacita = false;
				odkaz.removeAttribute('aria-busy');
				odkaz.style.opacity = '';
			});
	});

	return 1;
}
